Vue.asyncComponent('cms-dashboard-dead-links-check', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        statusTone: {
            type: String,
            default: 'success',
        },
        checks: {
            type: Array,
            default: () => [],
        },
        checksCount: {
            type: Number,
            default: 0,
        },
        failedCheckCount: {
            type: Number,
            default: 0,
        },
        pagesCount: {
            type: Number,
            default: 0,
        },
        brokenPageCount: {
            type: Number,
            default: 0,
        },
        brokenLinkCount: {
            type: Number,
            default: 0,
        },
        latestHost: {
            type: String,
            default: '',
        },
        latestCheckedAt: {
            type: String,
            default: '',
        },
        widgetCallbackStatuses: {
            type: Object,
            default: () => ({
                loading: false,
                success: null,
                failure: false,
            }),
        },
    },
    methods: {
        /**
         * Trigger a retry callback on the backend.
         *
         * @return {void}
         */
        onRetryClick() {
            this.$emit('retry');
        },

        /**
         * Return the host-level message with a safe fallback.
         *
         * @param {Object} check
         * @return {string}
         */
        getCheckMessage(check) {
            if (!check || typeof check !== 'object') {
                return this.$t('Geen details beschikbaar.');
            }

            const message = typeof check.message === 'string' ? check.message.trim() : '';
            if (message !== '') {
                return message;
            }

            const description = typeof check.description === 'string' ? check.description.trim() : '';
            if (description !== '') {
                return description;
            }

            const sitemapUrl = typeof check.sitemapUrl === 'string' ? check.sitemapUrl.trim() : '';
            if (sitemapUrl !== '') {
                return this.$t('Geen pagina\'s gevonden via sitemap') + ': ' + sitemapUrl;
            }

            return this.$t('Geen details beschikbaar.');
        },

        /**
         * Return only the failing pages for one host check.
         *
         * @param {Object} check
         * @return {Array}
         */
        getFailedPages(check) {
            if (!check || !Array.isArray(check.pages)) {
                return [];
            }

            return check.pages.filter((page) => !page.passed);
        },

        /**
         * Return the number of failing pages for one host check.
         *
         * @param {Object} check
         * @return {number}
         */
        getFailedPageCount(check) {
            return this.getFailedPages(check).length;
        },

        /**
         * Determine whether one host check contains failing pages.
         *
         * @param {Object} check
         * @return {boolean}
         */
        hasFailedPages(check) {
            const brokenPageCount = Number(check && check.brokenPageCount ? check.brokenPageCount : 0);
            if (brokenPageCount > 0) {
                return true;
            }

            return this.getFailedPageCount(check) > 0;
        },
    },
    created() {
        this.$on('refresh', () => {
            this.$root.$emit('cms-dashboard-refresh');
        });
    },
}, 'cms/dashboard/live/cms-dashboard-dead-links-check.html');
